import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../turbo_confirm"

// Guards a (turbo:false) form submit behind the custom confirm dialog.
// Wire the controller on the <form> and trigger it from the submit button's click:
//   data: { controller: "confirm-submit" }
//   button data: { action: "click->confirm-submit#confirm",
//                   confirm_submit_message_value: "...", confirm_submit_danger_value: true }
export default class extends Controller {
  static values = { message: String, danger: Boolean }

  async confirm(event) {
    event.preventDefault()
    if (await confirmDialog(this.messageValue, { danger: this.dangerValue })) {
      this.element.requestSubmit()
    }
  }
}
